import {
  CreateExclusionGroupEntityFe,
  ExclusionGroupEntityDto,
  ExperienceDto,
  ExperienceStatus,
} from "@intelligems/ig-types";

import { groupRounder, sortBy } from "./index";

export const getTestStatus = (
  entityId: string | undefined,
  allExperiences: ExperienceDto[]
): ExperienceStatus => {
  if (!entityId) {
    return "pending";
  } else {
    const foundTest = allExperiences.find(
      (experiment) => experiment.id === entityId
    );
    if (foundTest) {
      return foundTest.status ?? "pending";
    } else {
      return "pending";
    }
  }
};

export const ensureExclusionGroupEntityOrder = (
  exclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[]
) => {
  const sortedEntities = sortBy(exclusionGroupEntities, "order");

  const updatedExclusionGroupEntities:
    | CreateExclusionGroupEntityFe[]
    | ExclusionGroupEntityDto[] = [];

  sortedEntities.forEach(
    (entity: CreateExclusionGroupEntityFe | ExclusionGroupEntityDto, index) => {
      // @ts-ignore
      updatedExclusionGroupEntities.push({ ...entity, order: index });
    }
  );
  return updatedExclusionGroupEntities;
};

export const innerEnsureExclusionGroupEntityPercentage = (
  filteredExclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[],
  allExclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[]
) => {
  const filteredEntityIds = filteredExclusionGroupEntities.map(
    (entity) => entity.experienceId
  );

  return ensureExclusionGroupEntityOrder(
    groupRounder(
      allExclusionGroupEntities.map((entity) => ({
        ...entity,
        percentage: !filteredEntityIds.includes(entity.experienceId)
          ? 0
          : 100 / filteredExclusionGroupEntities.length,
      }))
    )
  );
};

export const ensureExclusionGroupEntityPercentage = (
  exclusionGroupEntities:
    | ExclusionGroupEntityDto[]
    | CreateExclusionGroupEntityFe[],
  experiencesList: ExperienceDto[]
) => {
  const filteredEntities = exclusionGroupEntities.filter(
    (entity) => getTestStatus(entity?.experienceId, experiencesList) !== "ended"
  );

  return innerEnsureExclusionGroupEntityPercentage(
    filteredEntities,
    exclusionGroupEntities
  );
};
